// Screen `run-detail` — design/screens/ExecutionDetail.dc.html — owner: S7.
import { createFileRoute } from '@tanstack/react-router';
import { RunDetailPage } from '../../../../../features/workflows/RunDetailPage';

export const Route = createFileRoute('/_app/automations/$workflowId/runs/$runId')({
  component: RunDetailRoute,
});

function RunDetailRoute() {
  const { workflowId, runId } = Route.useParams();
  return <RunDetailPage key={`${workflowId}:${runId}`} workflowId={workflowId} runId={runId} />;
}
